import type { ReactNode } from 'react';
import { useLingui } from '@lingui/react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

interface AppShellProps {
  children: ReactNode;
}

const DRAWER_ID = 'sidebar-drawer';

/**
 * DaisyUI drawer tabanlı tam-ekran layout.
 * - lg ve üzerinde sidebar her zaman açık (drawer-open)
 * - Mobilde hamburger toggle ile overlay sidebar açılır
 */
export function AppShell({ children }: AppShellProps) {
  const { _ } = useLingui();
  return (
    <div className="drawer lg:drawer-open min-h-screen">
      {/* Checkbox — drawer toggle kontrolü */}
      <input id={DRAWER_ID} type="checkbox" className="drawer-toggle" />

      {/* Ana içerik */}
      <div className="drawer-content flex flex-col bg-base-200">
        <Topbar drawerId={DRAWER_ID} />
        <main className="flex-1 p-4 sm:p-5 md:p-6">
          <div className="max-w-350 mx-auto w-full">{children}</div>
        </main>
      </div>

      {/* Sidebar */}
      <div className="drawer-side z-50">
        <label
          htmlFor={DRAWER_ID}
          className="drawer-overlay"
          aria-label={_({ id: 'layout.sidebar.closeLabel' })}
        />
        <Sidebar />
      </div>
    </div>
  );
}
